module.exports = __webpack_public_path__ + "img/PNMT_Card.b76afc50.svg";